module.exports = __webpack_public_path__ + "img/nav-right-search-below-toyota.10688977.png";